$('.form__form-group input').on('focus', function () {
    $(this).parents('.form__input-group').addClass('active');
    $(this).parents('.form__input-group-icon').addClass('active');
});

$('.form__form-group input').on('blur', function () {
    if (!$(this).val()) {
        $(this).parents('.form__input-group').removeClass('active');
    }
});

$('.form__form-group textarea').on('focus', function () {
    $(this).parents('.form__textarea-group').addClass('active');
});

$('.form__form-group textarea').on('blur', function () {
    if (!$(this).val()) {
        $(this).parents('.form__textarea-group').removeClass('active');
    }
});